import { type ComponentProps } from 'react'

import { cn } from 'src/shared/utils/cn'

const sizeVariants = {
  sm: {
    container: 'size-4',
    icon: 10,
  },
  md: {
    container: 'size-5',
    icon: 11,
  },
  lg: {
    container: 'size-6',
    icon: 13,
  },
  xl: {
    container: 'size-7',
    icon: 15,
  },
} as const

type Size = keyof typeof sizeVariants

interface NotificationSymbolProps {
  icon: React.ComponentType<ComponentProps<'svg'>>
  iconColor?: string
  bgColor?: string
  size?: Size
  className?: string
}

export function NotificationSymbol({
  icon: Icon,
  iconColor = 'text-primary',
  bgColor = 'bg-secondaryInverse',
  size = 'md',
  className,
}: NotificationSymbolProps) {
  const sizeConfig = sizeVariants[size]

  return (
    <div
      className={cn(
        'absolute -bottom-1 -right-1 flex items-center justify-center rounded-full ring-1 ring-background',
        sizeConfig.container,
        bgColor,
        className,
      )}
    >
      <Icon width={sizeConfig.icon} height={sizeConfig.icon} className={iconColor} />
    </div>
  )
}
